import { useEffect } from "react";
import { api } from "@/lib/api";

function visitorId() {
  let id = localStorage.getItem("visitor_id");
  if (!id) {
    id = window.crypto?.randomUUID ? window.crypto.randomUUID() : String(Math.random()).slice(2);
    localStorage.setItem("visitor_id", id);
  }
  return id;
}

// Non-essential analytics: only runs after explicit 'accepted' consent.
export function usePageTracking(pathname, consent) {
  useEffect(() => {
    if (consent !== "accepted" || pathname.startsWith("/admin")) {
      return;
    }
    const sent = sessionStorage.getItem("ref_sent");
    const referrer = sent ? "" : document.referrer || "";
    sessionStorage.setItem("ref_sent", "1");
    api.post("/track", { path: pathname, referrer, visitorId: visitorId() }).catch(() => {});
  }, [pathname, consent]);
}
